import SuperAdminForm from './_form'
import ResetPasswordModal from './reset-password-modal'
import template from './edit.pug'

export default Vue.extend({
  template: template(),
  components: {
    SuperAdminForm,
    ResetPasswordModal
  },
  data() {
    return {
      data: null,
      errors: {},
      loading: false,
      showResetModal: false
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        this.fetchUser(id)
        this.$setPageTitle(this.$t('superAdmins.edit.title'))
        this.$setBreadcrumbs([
          { label: this.$t('superAdmins.breadcrumbs.index'), route: { name: 'super-admin-index' } },
          { label: this.$t('superAdmins.breadcrumbs.edit'), route: {} }
        ])
      }
    }
  },
  methods: {
    fetchUser(id) {
      this.loading = true
      API.superAdmins.show(id).then(res => {
        this.data = res
      }).finally(() => {
        this.loading = false
      })
    },
    updateSuperAdmin(payload) {
      API.superAdmins.update(this.$route.params.id, payload).then(() => {
        this.$notifications.success(this.$t('superAdmins.edit.successfullyUpdated'))
        this.$router.push({ name: 'super-admin-index' })
      }).catch(err => {
        this.errors = err
      })
    },
    openResetPasswordModal() {
      this.showResetModal = true
    },
    closeResetPasswordModal() {
      this.showResetModal = false
    },
    // 🔐 Nuevo método que te faltaba
    resetPassword({ password, confirmPassword }) {
      API.superAdmins.resetPassword(this.$route.params.id, {
        password,
        confirmPassword
      })
      .then(() => {
        this.$notifications.success(this.$t('superAdmins.edit.passwordResetSuccess'))
        this.closeResetPasswordModal()
      })
      .catch(err => {
        this.$notifications.error(this.$t('superAdmins.edit.passwordResetError'))        
      })
    }
  }
})
